import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';
import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import { DeprecatedTabButton } from 'ui-components/components/DEPRECATED/tabs/tab-button';
import { noop } from 'ui-components/default-props/noop';

import style from './filterview.module.less';

const DEFAULT_VIEW_ID = 'default';

const FilterView = ({ count, displayName = '', filterViewId, isActive = false, launchEditViewModal = noop, onViewClick = noop }) => {
  const handleClick = useCallback(() => {
    onViewClick(filterViewId);
  }, [filterViewId, onViewClick]);

  const shouldShowCount = !!count || count === 0;
  const shouldRenderEditButton = isActive && filterViewId !== DEFAULT_VIEW_ID;

  return (
    <DeprecatedTabButton className={style['filterview-button']} onClick={handleClick} selected={isActive} theme='file-tab'>
      <div className={style['tab-label-container']}>
        <div className={style['tab-label']}>
          {displayName}
          {shouldShowCount && ` (${count})`}
        </div>
        {shouldRenderEditButton && (
          <div className={style['edit-icon']} onClick={launchEditViewModal}>
            <FontAwesomeIcon className={style['edit-svg']} icon={faPen} />
          </div>
        )}
      </div>
    </DeprecatedTabButton>
  );
};

FilterView.propTypes = {
  isActive: PropTypes.bool,
  filterViewId: PropTypes.string.isRequired,
  displayName: PropTypes.node,
  count: PropTypes.number,
  launchEditViewModal: PropTypes.func,
  onViewClick: PropTypes.func,
};

export default FilterView;
